import { useState } from "react";
import { useLocalStorage } from "react-use";
import mixpanel from "mixpanel-browser";

import cn from "app/utils/classnames";
import getCurrentDate from "app/utils/getCurrentDate";
import useSailThru from "app/game-over/useSailThru";

import PrivacyPolicy from "app/game-over/PrivacyPolicy";
import IconClose from "app/icons/IconClose";
import DialogModal from "app/ui/DialogModal";
import Header from "app/ui/Header";
import MenuButton from "app/ui/MenuButton";

export default function NewsletterSignupBanner() {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [success, setSuccess] = useState<boolean>(false);
  const [error, setError] = useState<string>("");
  const { signUp } = useSailThru();

  const [subscribed, setSubscribed] = useLocalStorage<boolean>(
    "TEDSPELLCHECK_NEWSLETTER_SUBSCRIBED",
    false,
  );

  if (subscribed) {
    return null;
  }

  function closeDialog() {
    setIsOpen(false);
    setError("");
  }

  return (
    <>
      <p className="mx-auto max-w-md text-center text-base font-medium -tracking-[0.015em]">
        Never miss Spellcheck.
        <br />
        <button
          type="button"
          className="inline appearance-none underline hover:no-underline cursor-pointer"
          onClick={() => {
            setIsOpen(true);
            mixpanel.track("email_subscribe");
          }}
        >
          Subscribe
        </button>{" "}
        for reminders.
      </p>

      <DialogModal isOpen={isOpen} onClose={closeDialog}>
        <div className="relative mx-auto my-8 grid w-full max-w-2xl bg-background px-10 py-8 text-center text-black">
          <button
            autoFocus
            className="absolute top-2 end-2 cursor-pointer"
            onClick={closeDialog}
          >
            <IconClose width={32} height={32} />
          </button>
          <div
            className={cn(
              "col-start-1 row-start-1 flex w-full flex-col items-center justify-center gap-8 transition-opacity",
              !success ? "invisible opacity-0" : "opacity-100",
            )}
          >
            <h2 className="font-condensed text-3.5xl max-w-64 text-center font-bold uppercase leading-none -tracking-[0.015em]">
              Thank you for subscribing!
            </h2>
            <button
              type="button"
              onClick={closeDialog}
              className="h-10 w-[12.375rem] rounded border border-black bg-background text-sm font-bold uppercase text-black"
            >
              Continue
            </button>
          </div>
          <form
            className={cn(
              "col-start-1 row-start-1 flex w-full flex-col items-center gap-8 border-0",
              success && "invisible",
            )}
            onSubmit={(e) => {
              e.preventDefault();
              setError("");

              const today = getCurrentDate();
              const formData = new FormData(e.target as HTMLFormElement);

              try {
                signUp({
                  email: formData.get("email") as string,
                  lists: {
                    "Master List": 1,
                    TED_Games_daily: 1,
                    TED_Games_Updates: 1,
                  },
                  vars: {
                    ted_games_daily_optin_date: today,
                    ted_games_daily_source: "spellcheck",
                    ted_games_updates_optin_date: today,
                    ted_games_updates_source: "spellcheck",
                  },
                  onSuccess: () => {
                    setSuccess(true);
                    setSubscribed(true);
                  },
                  onError: (error) => {
                    console.error("SailThru userSignUp error:", error);
                    setError(`${error}`);
                  },
                });
              } catch (error) {
                setError(`${error}`);
              }
            }}
          >
            <Header className="mt-6">Spellcheck Reminders</Header>
            {/* <h2 className="text-[3.5rem] font-bold uppercase leading-none -tracking-[0.015em]">
              Spellcheck Reminders
            </h2> */}

            <p className="mx-auto max-w-lg text-lg tracking-[0.03em]">
              Receive daily Spellcheck reminders and stay informed about the
              latest from TED.
            </p>

            <input
              aria-label="Email"
              name="email"
              type="email"
              id="email"
              placeholder="What's your email?"
              required
              onChange={() => setError("")}
              className={cn(
                "w-full max-w-sm",
                "font-mono text-md",
                "bg-background border border-black rounded-sm",
                "px-2.5 py-0.75",
                "leading-loose",
                "focus:outline-gray-300 focus:outline-2",
              )}
              aria-labelledby="email-error"
            />
            <label
              id="email-error"
              className={cn(
                "py-1 text-center text-xs font-medium -tracking-[0.01em] text-black",
                !error && "absolute opacity-0",
              )}
            >
              {error}
            </label>

            <MenuButton className="w-full max-w-50">Subscribe</MenuButton>
            <PrivacyPolicy />
          </form>
        </div>
      </DialogModal>
    </>
  );
}
